/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import './AylaTimeZone.css';
import { t } from 'i18next';

const DataSnapshot = ({ snapShot }) => (
  <span className="time-zone">
    {t('dataSnapshotTime')}
    {snapShot.date} {snapShot.time} {snapShot.zone}
  </span>
);

export default DataSnapshot;
